import { Button } from '@acpaas-ui/react-components';
import { useNavigate } from 'react-router-dom';
import SimpleSearch from '../../../../components/core/SimpleSearch';
import { ADMIN_PATH, ADMIN_TAB_PATHS } from '../../../../constants/paths.constants';
import { useAdminRouteGuard } from '../../../../hooks/admin/useAdminRouteGuard.hook';
import { useSimpleSearch } from '../../../../hooks/useSimpleSearch.hook';
import { ADMIN_OFFERINGS_RESOURCE } from '../../../../resources/admin/admin.offerings.resource';
import ResourceTable from '../../../core/ResourceTable';

const resource = ADMIN_OFFERINGS_RESOURCE;

const AdminOfferings = () => {
  const navigate = useNavigate();

  useAdminRouteGuard();

  return (
    <div className="spo-o-admin-offerings">
      <SimpleSearch className="u-margin-bottom-lg" {...useSimpleSearch(resource, 'title')} />
      <ResourceTable
        resource={resource}
        actions={[
          <Button
            key={'offering-add'}
            iconRight="ai-add"
            className="u-margin-right-sm"
            size="small"
            onClick={() => navigate(`${ADMIN_PATH}${ADMIN_TAB_PATHS.OFFERING_NEW.path}`)}
          >
            Aanbod toevoegen
          </Button>
        ]}
      />
    </div>
  );
};

export default AdminOfferings;
